/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

export const REMIX_PLACEHOLDER_WIDGET_KEY = 'ai-suggestions-remix-placeholder';

const styles = cssMap({
	placeholder: {
		width: '100%',
		height: '300px',
		borderRadius: token('radius.large', '8px'),
		backgroundColor: token('color.background.accent.blue.subtlest'),
		marginTop: token('space.150'),
		marginBottom: token('space.150'),
		pointerEvents: 'none',
	},
});

/** Marks where an accepted SUGGESTED_REMIX result will land while its card is active. */
export function RemixPlaceholder(): JSX.Element {
	return <div css={styles.placeholder} data-testid={REMIX_PLACEHOLDER_WIDGET_KEY} />;
}

/** Block-level, non-editable host that the RemixPlaceholder portal renders into. */
export function createRemixPlaceholderContainer(): HTMLElement {
	const element = document.createElement('div');
	element.contentEditable = 'false';
	element.setAttribute('style', 'display: block; width: 100%; pointer-events: none;');
	return element;
}
